import promise from 'promise';

const clear = () => {
    if ('caches' in window) {
        return caches.keys()
            .then(keys => Promise.all(
                keys.map(key => caches.delete(key))
            ))
            .then(() => true);
    }
    return promise.resolve(false);
};

/*
 * clearStaleUserSessions
 *
 * @param {string} userToken
 *
 * loops through all cache storage keys
 * checks the keys against the userToken
 *
 * if found - same user is logging in - do nothing
 * if not found - new user is logging in - clear all cache storage
 */
const clearStaleUserSessions = (userToken) => {
    if ('caches' in window) {
        return caches.keys()
            .then(keys => keys.some(key => key.indexOf(userToken) > -1)).then((response) => {
                // false - new user is logging in
                if (!response) {
                    return clear();
                }

                // true - same user is logging in
                return true;
            });
    }
    return promise.resolve(false);
};

export default {
    clear,
    clearStaleUserSessions,
};
